import { observer } from 'mobx-react-lite';
import PageLabelItem from './PageLabelItem';
import type { PageLabelItemProps, PageLabelItemValueProps } from './types';

export type { PageLabelItemProps, PageLabelItemValueProps };
export default observer(PageLabelItem); // MANUAL OVERRIDE
